import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Utils from "../Utils";
import useAssetProvider from "./useAssetProvider";
import { Edit, Cancel, Save } from "@material-ui/icons";
import Select from "react-select";
import {
	Grid,
	Box,
	Paper,
	makeStyles,
	Radio,
	RadioGroup,
	FormControlLabel,
	Checkbox,
	TextField,
	Typography,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	IconButton,
	Tooltip,
} from "@material-ui/core";
import Vendor from "./Vendor";
import { checkEditAccess } from "../Constants/utils"

const dropDownstyle = {
	control: (styles) => ({
		...styles,
		backgroundColor: "#f1f1f2",
		height: "38px",

		borderRadius: "0",
	}),
	indicatorSeparator: () => null,
};

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		backgroundColor: theme.palette.background.paper,
	},

	btnSave: {
		margin: "5px",
	},
	radioGroup: {
		display: "flex",
		flexWrap: "nowrap",
		flexDirection: "row",
	},
	table: {
		border: "1px solid rgba(224, 224, 224, 1)",
		"& tr:nth-child(even)": {
			backgroundColor: "FFFFFF",
		},
		"& tr:nth-child(odd)": {
			backgroundColor: "#F5F5F5",
		},
	},
}));

const FeeDetail = ({ fee }) => {
	const classes = useStyles();
	const { app, isReadOnly, stateSalesTaxData, onFeeUpdate, feeTypes, assets } = useAssetProvider();
	const [isEdit, setEdit] = useState(false);
	const { register, handleSubmit, control, reset } = useForm();
	const [isRefresh, setIsRefresh] = useState(true);
	const [vendorDetails, setVendorDetails] = useState(null)
	const [feeType, setFeeType] = useState(fee?.type);
	const [assetName, setAssetName] = useState("");
	const [disableFeeOverride, setDisableFeeOverride] = useState(isReadOnly);
	const [feeOverrideAmount, setFeeOverrideAmount] = useState(fee?.override_amount ?? 0);

	useEffect(() => {
		if (isReadOnly)
			setDisableFeeOverride(isReadOnly);
		else if (app.status === "Document Data Review")
			setDisableFeeOverride(!isEdit);
		else if (['Documents Sent', 'Document Check In'].includes(app.status)) {
			if (feeType === "Documentation" || feeType === "Installation")
				setDisableFeeOverride(false);
			else
				setDisableFeeOverride(true);

		}
	}, [app, isEdit, isReadOnly]);

	useEffect(() => {
		if (fee && isRefresh) {
			try {
				reset({
					...fee,
					exclude_loan: String(fee.exclude_loan),
					exclude_trac: String(fee.exclude_trac),
					exclude_fmv: String(fee.exclude_fmv),
					exclude_out: String(fee.exclude_out),
					exclude_101: String(fee.exclude_101),
				});
			} catch {
				console.log("fee", fee);
			} finally {
				setIsRefresh(false);
			}
		}
	}, [reset, fee, isRefresh]);

	const formSubmit = (data) => {
		setEdit(false);
		if (
			["Documents Sent", "Document Data Review", "Document Check In"].includes(
				app.status
			)
		) {
			if (data?.override_amount > fee?.amount) {
				return;
			}
		}
		const selectedVendor = vendorDetails ?? {};
		const vendorShortId =
			typeof selectedVendor.short_id === "string" && selectedVendor.short_id
				? selectedVendor.short_id
				: typeof selectedVendor.id === "string" && selectedVendor.id.startsWith("ACC-")
					? selectedVendor.id
					: typeof fee?.vendor === "string"
						? fee.vendor
						: "";
		const vendorName = selectedVendor.name ?? fee?.vendor_name ?? "";
		const vendorStreet = selectedVendor.street ?? fee?.vendor_street ?? "";
		const vendorCity = selectedVendor.city ?? fee?.vendor_city ?? "";
		const vendorState = selectedVendor.state ?? fee?.vendor_state ?? "";
		const vendorZip =
			selectedVendor.zip_code ?? selectedVendor.zipcode ?? fee?.vendor_zipcode ?? fee?.vendor_zip ?? "";
		const vendorCountry = selectedVendor.country ?? fee?.vendor_country ?? "";
		const updatedFee = {
			...fee,
			...data,
			override_amount: feeOverrideAmount,
			exclude_loan: data.exclude_loan === "true",
			exclude_trac: data.exclude_trac === "true",
			exclude_fmv: data.exclude_fmv === "true",
			exclude_out: data.exclude_out === "true",
			exclude_101: data.exclude_101 === "true",
			vendor: vendorShortId,
			vendor_name: vendorName,
			vendor_street: vendorStreet,
			vendor_city: vendorCity,
			vendor_state: vendorState,
			vendor_zipcode: vendorZip,
			vendor_country: vendorCountry,
			application_asset_name: assetName ?? ""
		};
		delete updatedFee.vendor_id;
		if (updatedFee?.override_amount === 0) {
			delete updatedFee?.override_amount;
		}

		onFeeUpdate(updatedFee);
		// console.log(" Check the fee object ", updatedFee);
	};

	const payableToList = [
		{ label: "Lessor", value: "Lessor" },
		{ label: "Vendor", value: "Vendor" },
		{ label: "Other", value: "Other" },
	];

	useEffect(() => {
		if (fee.application_asset_name) {
			setAssetName(fee.application_asset_name);
		}
		else
			setAssetName("");
		fee.application_asset = "";
	}, [fee.application_asset_name])

	return (
		<div className={classes.root}>
			<form onSubmit={handleSubmit(formSubmit)}>
				<Box p={1}>
					{!(feeType && feeType.includes("Sales Tax")) && (
						<Grid container spacing={2}>
							<Grid item xs={6}>
								<TableContainer component={Paper}>
									<Table className={classes.table}>
										<TableHead>
											<TableRow>
												<TableCell colSpan={2} align="center">
													<Typography variant="subtitle2">Details</Typography>
												</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											<TableRow>
												<TableCell colSpan={2}>
													<Vendor
														asset={null}
														currentLocation={null}
														currentVendor={fee.vendor}
														type={'fee'}
														updateFeeVendor={setVendorDetails}
														isEdit={isEdit}
													/>
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell>
													<Typography variant="body1">Payable To</Typography>
												</TableCell>
												<TableCell>
													<Controller
														name="payable_to"
														id="payable_to"
														styles={dropDownstyle}
														control={control}
														defaultValue={fee?.payable_to}
														disabled={isReadOnly || !isEdit}
														render={({ onChange, value, ref }) => (
															<Select
																inputRef={ref}
																menuPlacement="bottom"
																options={payableToList}
																value={payableToList.find((c) => c.value === value) || {}}
																isDisabled={isReadOnly || !isEdit}
																onChange={(val) => {
																	onChange(val.value);

																}}
															/>
														)}
													/>
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell>
													<Typography variant="body1">Description</Typography>
												</TableCell>
												<TableCell>
													<Controller
														as={TextField}
														margin="normal"
														name="description"
														id="description"
														control={control}
														register={register}
														disabled={isReadOnly || !isEdit}
														defaultValue={fee.description ? fee.description : "N/A"}
													/>
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell>
													<Typography variant="body1">Notes</Typography>
												</TableCell>
												<TableCell>
													<Controller
														as={TextField}
														margin="normal"
														name="notes"
														id="notes"
														type="text"
														control={control}
														register={register}
														defaultValue={fee.notes || ""}
														disabled={isReadOnly || !isEdit}
													/>
												</TableCell>
											</TableRow>
										</TableBody>
									</Table>
								</TableContainer>
							</Grid>
							<Grid item xs={6}>
								<TableContainer component={Paper}>
									<Table className={classes.table}>
										<TableHead>
											<TableRow>
												<TableCell colSpan={2} align="center">
													<Typography variant="subtitle2">Details</Typography>
												</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											<TableRow>
												<TableCell>
													<Typography variant="body1">Type</Typography>
												</TableCell>
												<TableCell>
													<Controller
														name="type"
														id="type"
														styles={dropDownstyle}
														control={control}
														defaultValue={feeType}
														disabled={isReadOnly || !isEdit}
														render={({ onChange, value, ref }) => (
															<Select
																inputRef={ref}
																menuPlacement="bottom"
																options={feeTypes || []}
																value={feeTypes?.find((c) => c.value === value) || {}}
																isDisabled={isReadOnly || !isEdit}
																onChange={(val) => {
																	onChange(val.value);
																	setFeeType(val.value);
																}}
															/>
														)}
													/>
												</TableCell>
											</TableRow>

											<TableRow>
												<TableCell>
													<Typography variant="body1">Override Amount</Typography>
												</TableCell>
												<TableCell>
													<Controller
														name="override_amount"
														id="override_amount"
														control={control}
														defaultValue={feeOverrideAmount}
														render={() => (
															<TextField
																value={feeOverrideAmount}
																type="number"
																InputProps={{
																	inputProps: {
																		min: 0
																	}
																}}
																isDisabled={disableFeeOverride}
																onChange={(e) => {
																	let num = e.target.value;
																	if (num < 0) {
																		setFeeOverrideAmount("");
																	} else
																		setFeeOverrideAmount(num);
																}}
																error={feeOverrideAmount > fee.amount}
																helperText={feeOverrideAmount > fee.amount ? 'Override should be < Fee Amount' : ""}
																disabled={disableFeeOverride}
															/>
														)}
													/>
													{!isReadOnly && (feeOverrideAmount < fee.amount) &&
														['Documents Sent', 'Document Check In'].includes(app?.status) &&
														['Installation', 'Documentation'].includes(fee?.type) &&
														<>
															<Tooltip title="Save" placement="top">
																<IconButton
																	color="primary"
																	style={{ marginTop: "-0.15rem" }}
																	type="submit">
																	<Save />
																</IconButton>
															</Tooltip>
														</>
													}
												</TableCell>
											</TableRow>

											<TableRow>
												<TableCell>
													<Typography variant="body1">Amount</Typography>
												</TableCell>
												<TableCell>
													<Typography variant="body1" id="amount">
														{"$" + Utils.formatCurrencyNumber(fee.amount)}
													</Typography>
												</TableCell>
											</TableRow>
										</TableBody>
									</Table>
								</TableContainer>
							</Grid>
						</Grid>)}
					{/* ui for fee type == Sales Tax */}
					{/* fee.type === "Sales Tax" */}
					{(feeType && feeType.includes("Sales Tax")) && (
						<Grid container spacing={2}>
							<Grid item xs={6}>
								<TableContainer component={Paper}>
									<Table className={classes.table}>
										<TableHead>
											<TableRow>
												<TableCell colSpan={2} align="center">
													<Typography variant="subtitle2">Details</Typography>
												</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											<TableRow>
												<TableCell colSpan={2}>
													<Vendor
														asset={null}
														currentLocation={null}
														currentVendor={fee.vendor}
														type={'fee'}
														updateFeeVendor={setVendorDetails}
														isEdit={isEdit}
													/>
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell>
													<Typography variant="body1">Payable To</Typography>
												</TableCell>
												<TableCell>
													<Controller
														name="payable_to"
														id="payable_to"
														styles={dropDownstyle}
														control={control}
														defaultValue={fee?.payable_to}
														disabled={isReadOnly || !isEdit}
														render={({ onChange, value, ref }) => (
															<Select
																inputRef={ref}
																menuPlacement="bottom"
																options={payableToList}
																value={payableToList.find((c) => c.value === value) || {}}
																isDisabled={isReadOnly || !isEdit}
																onChange={(val) => {
																	onChange(val.value);
																}}
															/>
														)}
													/>
												</TableCell>
											</TableRow>

											<TableRow>
												<TableCell>
													<Typography variant="body1">Description</Typography>
												</TableCell>
												<TableCell>

													<Controller
														as={TextField}
														margin="normal"
														name="description"
														id="description"
														control={control}
														register={register}
														disabled={isReadOnly || !isEdit}
														defaultValue={fee.description ? fee.description : "N/A"}
													/>

												</TableCell>
											</TableRow>

											<TableRow>
												<TableCell>
													<Typography variant="body1">Type</Typography>
												</TableCell>
												{/* <TableCell>
												<Typography variant="body1" id="type">
													{fee.type}
												</Typography>
											</TableCell> */}
												<TableCell>
													{/* <Typography variant="body1" id="payable_to">
													{fee.payable_to}
												</Typography> */}
													<Controller
														name="type"
														id="type"
														styles={dropDownstyle}
														control={control}
														defaultValue={feeType}
														disabled={isReadOnly || !isEdit}
														render={({ onChange, value, ref }) => (
															<Select
																inputRef={ref}
																menuPlacement="bottom"
																options={feeTypes || []}
																value={feeTypes?.find((c) => c.value === value) || ""}
																isDisabled={isReadOnly || !isEdit}
																onChange={(val) => {
																	onChange(val.value);
																	setFeeType(val.value);
																}}
															/>
														)}
													/>
												</TableCell>
											</TableRow>

											<TableRow>
												<TableCell>
													<Typography variant="body1">Override Amount</Typography>
												</TableCell>
												<TableCell>
													<Controller
														as={TextField}
														margin="normal"
														name="override_amount"
														id="override_amount"
														type="number"
														control={control}
														register={register}
														defaultValue={fee.override_amount || 0}
														disabled={isReadOnly || !isEdit}
													/>
												</TableCell>
											</TableRow>

											<TableRow>
												<TableCell>
													<Typography variant="body1">Amount</Typography>
												</TableCell>
												<TableCell>
													<Typography variant="body1" id="amount">
														{"$" + Utils.formatCurrencyNumber(fee.amount)}
													</Typography>
												</TableCell>
											</TableRow>

											<TableRow>
												<TableCell>
													<Typography variant="body1">Notes</Typography>
												</TableCell>
												<TableCell>
													<Controller
														as={TextField}
														margin="normal"
														name="notes"
														id="notes"
														type="text"
														control={control}
														register={register}
														defaultValue={fee.notes || ""}
														disabled={isReadOnly || !isEdit}
													/>
												</TableCell>
											</TableRow>
										</TableBody>
									</Table>
								</TableContainer>
							</Grid>
							<Grid item xs={6}>
								<TableContainer component={Paper} style={{ overflow: "hidden" }}>
									<Table className={classes.table}>
										<TableHead>
											<TableRow>
												<TableCell>
													<Typography variant="subtitle2">Structure</Typography>
												</TableCell>
												<TableCell>
													<Typography variant="subtitle2">Finance Sales Tax</Typography>
												</TableCell>
												<TableCell>
													<Typography variant="subtitle2">System Suggestion</Typography>
												</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											<TableRow>
												<TableCell>
													<Typography variant="body1">Loan</Typography>
												</TableCell>
												<TableCell>
													<Controller
														name="exclude_loan"
														control={control}
														as={
															<RadioGroup className={classes.radioGroup}>
																<FormControlLabel
																	value="true"
																	control={<Radio size="small" />}
																	label="Exclude"
																	disabled={isReadOnly || !isEdit}
																/>
																<FormControlLabel
																	value="false"
																	control={<Radio size="small" />}
																	label="Include"
																	disabled={isReadOnly || !isEdit}
																/>
															</RadioGroup>
														}
														defaultValue={
															fee.exclude_loan ? String(fee.exclude_loan) : "true"
														}
													/>
												</TableCell>
												<TableCell>
													<Typography variant="body1">
														{stateSalesTaxData && stateSalesTaxData.loan === "On Stream"
															? "Exclude"
															: "Include"}
													</Typography>
												</TableCell>
											</TableRow>

											<TableRow>
												<TableCell>
													<Typography variant="body1">TRAC</Typography>
												</TableCell>
												<TableCell>
													<Controller
														name="exclude_trac"
														control={control}
														as={
															<RadioGroup className={classes.radioGroup}>
																<FormControlLabel
																	value="true"
																	control={<Radio size="small" />}
																	label="Exclude"
																	disabled={isReadOnly || !isEdit}
																/>
																<FormControlLabel
																	value="false"
																	control={<Radio size="small" />}
																	label="Include"
																	disabled={isReadOnly || !isEdit}
																/>
															</RadioGroup>
														}
														defaultValue={
															fee.exclude_trac ? String(fee.exclude_trac) : "true"
														}
													/>
												</TableCell>
												<TableCell>
													<Typography variant="body1">
														{stateSalesTaxData && stateSalesTaxData.trac === "On Stream"
															? "Exclude"
															: "Include"}
													</Typography>
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell>
													<Typography variant="body1">FMV</Typography>
												</TableCell>
												<TableCell>
													<Controller
														name="exclude_fmv"
														control={control}
														as={
															<RadioGroup className={classes.radioGroup}>
																<FormControlLabel
																	value="true"
																	control={<Radio size="small" />}
																	label="Exclude"
																	disabled={isReadOnly || !isEdit}
																/>
																<FormControlLabel
																	value="false"
																	control={<Radio size="small" />}
																	label="Include"
																	disabled={isReadOnly || !isEdit}
																/>
															</RadioGroup>
														}
														defaultValue={fee.exclude_fmv ? String(fee.exclude_fmv) : "true"}
													/>
												</TableCell>
												<TableCell>
													<Typography variant="body1">
														{stateSalesTaxData && stateSalesTaxData.fmv === "On Stream"
															? "Exclude"
															: "Include"}
													</Typography>
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell>
													<Typography variant="body1">$1 OUT</Typography>
												</TableCell>
												<TableCell>
													<Controller
														name="exclude_out"
														control={control}
														as={
															<RadioGroup className={classes.radioGroup}>
																<FormControlLabel
																	value="true"
																	control={<Radio size="small" />}
																	label="Exclude"
																	disabled={isReadOnly || !isEdit}
																/>
																<FormControlLabel
																	value="false"
																	control={<Radio size="small" />}
																	label="Include"
																	disabled={isReadOnly || !isEdit}
																/>
															</RadioGroup>
														}
														defaultValue={fee.exclude_out ? String(fee.exclude_out) : "true"}
													/>
												</TableCell>
												<TableCell>
													<Typography variant="body1">
														{stateSalesTaxData &&
															stateSalesTaxData.one_dollar_out === "On Stream"
															? "Exclude"
															: "Include"}
													</Typography>
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell>
													<Typography variant="body1">$101 OUT</Typography>
												</TableCell>
												<TableCell>
													<Controller
														name="exclude_101"
														control={control}
														as={
															<RadioGroup className={classes.radioGroup}>
																<FormControlLabel
																	value="true"
																	control={<Radio size="small" />}
																	label="Exclude"
																	disabled={isReadOnly || !isEdit}
																/>
																<FormControlLabel
																	value="false"
																	control={<Radio size="small" />}
																	label="Include"
																	disabled={isReadOnly || !isEdit}
																/>
															</RadioGroup>
														}
														defaultValue={fee.exclude_101 ? String(fee.exclude_101) : "true"}
													/>
												</TableCell>
												<TableCell>
													<Typography variant="body1">
														{stateSalesTaxData &&
															stateSalesTaxData.one_hundred_one_dollar_out === "On Stream"
															? "Exclude"
															: "Include"}
													</Typography>
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell colSpan={3}>
													<Controller
														as={Checkbox}
														color="primary"
														name="is_approved"
														id="is_approved"
														type="checkbox"
														control={control}
														defaultValue={fee.is_approved || false}
														disabled={isReadOnly || !isEdit}
													/>

													<Typography
														variant="body1"
														style={{
															display: "inline",
														}}>
														I hereby approve the tax-treatment for this deal.
													</Typography>
												</TableCell>
											</TableRow>
										</TableBody>
									</Table>
								</TableContainer>
							</Grid>
						</Grid>
					)}
					<Grid >
						<div xs='4px' className="form-two-column">
							<div style={{ display: 'grid' }}>
								<div className="form__content" style={{ marginTop: "2rem", marginBottom: "1rem" }}>
									<span>
										<Typography variant="subtitle2">Select an Asset for this Fee (optional)</Typography>
									</span>
								</div>
								<Table className={classes.table} size="small" aria-label="simple table"
									style={{
										padding: "2px 5px 3px 5px",
									}} >
									<TableHead className="tableHead">
										<TableRow style={{ color: "white" }}>
											<TableCell align="left">Action</TableCell>
											<TableCell align="left">Make</TableCell>
											<TableCell align="left">Year</TableCell>
											<TableCell align="left">Model</TableCell>
											<TableCell align="left">Vin/Serial</TableCell>
											<TableCell align="left">Price</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{assets &&
											assets.map((item) => (
												<TableRow>
													<TableCell>
														<Radio
															disabled={isReadOnly || !isEdit}
															checked={assetName ? assetName === item.name : false}
															name="Radio-button"
															color="primary"
															onClick={() => {
																if (assetName === item.name) {
																	setAssetName("");
																	fee.application_asset = "";
																}
																else
																	setAssetName(item.name)
															}}>
														</Radio>
													</TableCell>
													<TableCell align="left">{item.override_make ? item.override_make : item.make}</TableCell>
													<TableCell align="left">{item.override_year ? item.override_year : item.year}</TableCell>
													<TableCell align="left">{item.override_model ? item.override_model : item.model}</TableCell>
													<TableCell align="left">{item.override_vin ? item.override_vin : item.vin ?? '-'}</TableCell>
													<TableCell align="left">$ {Utils.formatCurrencyNumber(item.price)}</TableCell>
												</TableRow>
											))}
									</TableBody>
								</Table>
							</div>
						</div>
					</Grid>

					{!isReadOnly && checkEditAccess() && (
						<Grid container justifyContent="flex-end" direction="row">
							{!isEdit && (
								<Grid item align="right">
									<Tooltip title="Edit" placement="top">
										<IconButton
											color="primary"
											style={{ margin: "0.25rem" }}
											onClick={() => setEdit(true)}>
											<Edit />
										</IconButton>
									</Tooltip>
								</Grid>
							)}

							{isEdit && (
								<Grid item align="right">
									<Tooltip title="Cancel" placement="top">
										<IconButton
											color="secondary"
											style={{ margin: "0.25rem" }}
											onClick={() => {
												setEdit(false);
												setIsRefresh(true);
											}}>
											<Cancel />
										</IconButton>
									</Tooltip>
									<Tooltip title="Save" placement="top">
										<IconButton
											color="primary"
											style={{ margin: "0.25rem" }}
											type="submit">
											<Save />
										</IconButton>
									</Tooltip>
								</Grid>
							)}
						</Grid>
					)}
				</Box>
			</form>
		</div>
	);
};
export default FeeDetail;
